import src from "IMAGE";
export default { src, width: 248, height: 248, blurWidth: 0, blurHeight: 0};
